function Button({ title, type = 'button', ...props }) {
	return (
		<button type={type} {...props}>
			{title}
		</button>
	);
}

export default Button;
